var Label = /** @class */ (function () {
    function Label(init) {
        this.includeResolved = false;
        this.includeUnresolved = true;
        Object.assign(this, init);
    }
    return Label;
}());
export { Label };
